/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_ReportInputs */

const en_audit_report = /** @type {(inputs: Audit_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report`)
};

const es_audit_report = /** @type {(inputs: Audit_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporte`)
};

/**
* | output |
* | --- |
* | "Report" |
*
* @param {Audit_ReportInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_report = /** @type {((inputs?: Audit_ReportInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_ReportInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_report(inputs)
	return es_audit_report(inputs)
});